// extracted by mini-css-extract-plugin
export default {"title":"Roles_title__saqH4","tableContainer":"Roles_tableContainer__GsGKD"};